import React, { useState, useEffect, useCallback } from "react";
import { Event } from "../../types/events";
import EventCard from "./EventCard";
import LoadingIndicator from "../ui/LoadingIndicator";
import dreamWorldProvider from "../../DreamWorldProvider";

const PastEvents: React.FC = () => {
  const [events, setEvents] = useState<Event[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchPastEvents = useCallback(async () => {
    setIsLoading(true);
    try {
      const fetchedEvents = await dreamWorldProvider.getPastEvents();
      setEvents(fetchedEvents);
    } catch (error) {
      console.error("Error fetching past events:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPastEvents();
  }, [fetchPastEvents]);

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (events.length === 0) {
    return (
      <p className="text-center text-gray-400 mt-8">No past events found.</p>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {events.map((event) => (
        <EventCard key={event.id} event={event} />
      ))}
    </div>
  );
};

export default PastEvents;
